var _path, _path2, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftStack({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    style: {
      width: 18,
      height: 16
    },
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.24558 8.97889H3.07765V7.95633H8.24558L5.96816 5.21383L6.56851 4.49088L9.87085 8.46761L6.56851 12.4443L5.96816 11.7214L8.24558 8.97889Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2456 8.97889H11.0777V7.95633H16.2456L13.9682 5.21383L14.5685 4.49088L17.8708 8.46761L14.5685 12.4443L13.9682 11.7214L16.2456 8.97889Z",
    fill: "currentColor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.207764,
    width: 1.77778,
    height: 16,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftStack);
export default __webpack_public_path__ + "static/media/left_stack.b7c0f36b1fcd2a70a22efdafe08cc432.svg";
export { ForwardRef as ReactComponent };